/* ============================================================
   GlowEnvy — Shopify theme interactions
   Ported from the custom build: ritual clock (ambient warmth),
   scroll reveals, parallax bands, and the signature scroll-pinned
   Ritual-Method orb. Cart + i18n are handled by Shopify, not here.
   Accessibility: every motion path respects prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var onReady = function (fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); };
  var reduce = function () { return matchMedia("(prefers-reduced-motion: reduce)").matches; };

  /* Ritual clock — ambient warmth shifts by local hour */
  function ritualClock() {
    var h = new Date().getHours(), warm, tint, greet;
    if (h >= 5 && h < 11)  { warm = .10; tint = "rgba(200,169,106,.10)"; greet = "dawn"; }
    else if (h >= 11 && h < 17) { warm = .04; tint = "rgba(140,154,130,.06)"; greet = "day"; }
    else if (h >= 17 && h < 21) { warm = .85; tint = "rgba(200,140,70,.16)"; greet = "dusk"; }
    else { warm = 1; tint = "rgba(120,90,160,.14)"; greet = "night"; }
    var root = document.documentElement;
    root.style.setProperty("--amb-warm", warm);
    root.style.setProperty("--amb-tint", tint);
    root.setAttribute("data-phase", greet);
    var el = document.querySelector("[data-ritual-greet]");
    if (el && el.getAttribute("data-" + greet)) el.textContent = el.getAttribute("data-" + greet);
  }

  /* Sticky header state */
  function header() {
    var h = document.querySelector(".header"); if (!h) return;
    var on = function () { h.classList.toggle("is-stuck", window.scrollY > 12); };
    on(); window.addEventListener("scroll", on, { passive: true });
  }

  /* Mobile nav */
  function nav() {
    var burger = document.querySelector(".burger"), links = document.querySelector(".nav__links");
    if (!burger || !links) return;
    var toggle = function (force) {
      var open = force == null ? !links.classList.contains("open") : force;
      links.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", String(open));
      document.documentElement.classList.toggle("nav-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    };
    burger.addEventListener("click", function () { toggle(); });
    links.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { toggle(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") toggle(false); });
    window.addEventListener("resize", function () { if (!matchMedia("(max-width: 880px)").matches) toggle(false); }, { passive: true });
  }

  /* Scroll reveals */
  function reveal() {
    var pending = function () { return document.querySelectorAll(".reveal:not(.in)"); };
    var showAll = function () { pending().forEach(function (e) { e.classList.add("in"); }); };
    // In the Shopify theme editor (design mode), reveal everything immediately so newly added
    // blocks/sections are visible right away instead of staying at opacity:0.
    if (reduce() || !("IntersectionObserver" in window) || (window.Shopify && Shopify.designMode)) { showAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: .12, rootMargin: "0px 0px -8% 0px" });
    pending().forEach(function (e) { io.observe(e); });
  }

  /* Parallax on full-bleed band media */
  function parallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
    if (!els.length || reduce()) return;
    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) return;
        var pct = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = "translate3d(0," + (-pct * 64).toFixed(1) + "px,0)";
      });
      ticking = false;
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  /* Signature: scroll-pinned Ritual-Method orb that swaps product + accent per step */
  function ritualSequence() {
    var seq = document.querySelector(".rseq"); if (!seq) return;
    var steps = Array.prototype.slice.call(seq.querySelectorAll(".rstep"));
    var prods = Array.prototype.slice.call(seq.querySelectorAll(".rseq__prod"));
    var sticky = seq.querySelector(".rseq__sticky");
    var orb = seq.querySelector("[data-rseq-orb]");
    var numEl = seq.querySelector("[data-rseq-num]");
    var active = -1;
    var setActive = function (i) {
      if (i < 0 || i === active) return;
      active = i;
      steps.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
      prods.forEach(function (p, k) { p.classList.toggle("is-active", k === i); });
      if (numEl) numEl.textContent = ("0" + (i + 1)).slice(-2);
      var accent = getComputedStyle(steps[i]).getPropertyValue("--accent").trim();
      if (orb && accent) orb.style.setProperty("--accent", accent);
    };
    setActive(0);
    var isMobile = function () { return window.matchMedia("(max-width: 879px)").matches; };
    var ticking = false;
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight, mid = vh / 2, best = active < 0 ? 0 : active, bestDist = Infinity;
        steps.forEach(function (s, i) {
          var r = s.getBoundingClientRect();
          var d = Math.abs(r.top + r.height / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        setActive(best);
        // Mobile: fade the bubble in above step 1 and out as you scroll past the last step
        if (orb || sticky) {
          if (isMobile()) {
            var sr = seq.getBoundingClientRect();
            var visible = sr.top < vh && sr.bottom > 0;
            if (sticky) sticky.classList.toggle("is-visible", visible);
            if (orb) orb.style.opacity = visible ? "1" : "0";
          } else {
            if (sticky) sticky.classList.remove("is-visible");
            if (orb && orb.style.opacity) orb.style.opacity = "";
          }
        }
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    onScroll();
  }

  /* Mobile: gently auto-scroll the product carousel through a few cards on first view,
     so people know it's swipeable (they tap "Shop all" to see the rest). */
  function carouselHint() {
    var els = Array.prototype.slice.call(document.querySelectorAll(".hscroll"));
    if (!els.length) return;
    els.forEach(function (el) {
      var started = false, cancelled = false, lastSet = 0;
      var cancel = function () { if (cancelled) return; cancelled = true; el.style.scrollSnapType = ""; };
      // Cancel only on a real horizontal swipe (scrollLeft jumps away from where the tween set it)
      el.addEventListener("scroll", function () {
        if (started && !cancelled && Math.abs(el.scrollLeft - lastSet) > 24) cancel();
      }, { passive: true });
      var tween = function (to, dur, cb) {
        var start = el.scrollLeft, delta = to - start, t0 = null;
        (function frame(ts) {
          if (cancelled) return;
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; // easeInOutQuad
          el.scrollLeft = start + delta * e; lastSet = el.scrollLeft;
          if (p < 1) requestAnimationFrame(frame); else if (cb) cb();
        })();
      };
      var run = function () {
        el.style.scrollSnapType = "none"; // snap fights the slow tween
        var card = el.querySelector(".card");
        var step = (card ? card.getBoundingClientRect().width : el.clientWidth * 0.72) + 16;
        var stops = [step, step * 2], i = 0;
        var go = function () {
          if (cancelled) return;
          if (i >= stops.length) { el.style.scrollSnapType = ""; return; }
          tween(stops[i], 2600, function () { i++; setTimeout(go, 1100); });
        };
        setTimeout(go, 700);
      };
      // Plain scroll-based trigger (more reliable than IntersectionObserver inside the Shopify
      // editor). Fires once the carousel is well into view; skips desktop (one non-scrolling row).
      var maybeStart = function () {
        if (started) return;
        if (el.scrollWidth <= el.clientWidth + 12) return; // not scrollable → nothing to hint
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.82 && r.bottom > window.innerHeight * 0.2) {
          started = true;
          window.removeEventListener("scroll", maybeStart);
          run();
        }
      };
      window.addEventListener("scroll", maybeStart, { passive: true });
      window.addEventListener("resize", maybeStart, { passive: true });
      // Poll as a fallback — guarantees it fires when the carousel comes into view even if
      // scroll/IntersectionObserver events don't fire reliably (e.g. inside the Shopify editor).
      var poll = setInterval(function () { maybeStart(); if (started) clearInterval(poll); }, 300);
      maybeStart();
    });
  }

  /* Headroom: hide the sticky header on scroll-down, reveal it on scroll-up,
     so you can jump to another page without scrolling back to the top. */
  function headroom() {
    var h = document.querySelector(".header"); if (!h) return;
    var last = window.scrollY || 0, ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        if (y < 90) h.classList.remove("header--hidden");
        else if (y > last + 8) h.classList.add("header--hidden");
        else if (y < last - 8) h.classList.remove("header--hidden");
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  onReady(function () {
    [ritualClock, header, nav, reveal, parallax, ritualSequence, carouselHint].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console && console.warn) console.warn("GlowEnvy init error:", e); }
    });
  });

  // Re-run reveal when a section is edited/added in the theme editor so its content shows.
  document.addEventListener("shopify:section:load", function () { try { reveal(); } catch (e) {} });
})();
